import Model from '@/models/Model'

export default class PaymentCondition extends Model {

    resource()
    {
        return 'pch_payment_condition'
    }
}